import React, { useContext } from 'react';
import { Checkbox } from '@sm/wds-react';
import { SearchConsumer } from '../SearchContext';

import { DEFAULT_FILTERS, INTEGRATE_TYPES, AVAILABLE_IN } from '../SearchContext/FilterOptions';
import CategoriesContext from '../CategoriesContext';

const FilterNav = () => {
  const { isLoading: isCategoriesLoading, categories = [] } = useContext(CategoriesContext);

  return (
    <SearchConsumer>
      {({ filters, updateFilter }) => {
        const isChecked = filter => filters.includes(filter);
        const handleChange = filter =>
          updateFilter(isChecked(filter) ? filters.filter(f => f !== filter) : [...filters, filter]);

        const renderFilter = ({ name, title, key, id }) => (
          <div key={id || key}>
            <Checkbox
              label={name || title}
              id={id || key}
              data-testid="FilterNav__CategoryItem"
              onChange={() => handleChange(id)}
              checked={isChecked(id)}
            />
          </div>
        );

        return (
          <div>
            <h2>Filter</h2>
            {DEFAULT_FILTERS.map(cat => renderFilter(cat))}
            <h3>App Category</h3>
            {!isCategoriesLoading && categories.map(cat => renderFilter(cat))}
            <h3>Integration Type</h3>
            {INTEGRATE_TYPES.map(cat => renderFilter(cat))}
            <h3>Available in</h3>
            {AVAILABLE_IN.map(cat => renderFilter(cat))}
          </div>
        );
      }}
    </SearchConsumer>
  );
};

export default FilterNav;
